module.exports = "/_next/static/images/reactify-logo-9a464ff6a45f82eb53d8e52d0881a4b2.png";